import { storageKeys } from 'constants/enums/storageKeys.enum';
import { storageTypes } from 'constants/enums/storageTypes.enum';

const storageDefines: Readonly<Record<storageKeys, storageTypes>> = {
  [storageKeys.SampleLocal]: storageTypes.local,
  [storageKeys.SampleSession]: storageTypes.session,
  [storageKeys.SampleCookies]: storageTypes.cookies,
  [storageKeys.AcceptCookieConsent]: storageTypes.session,
  [storageKeys.ApplicationId]: storageTypes.session,
  [storageKeys.ChannelId]: storageTypes.session,
  [storageKeys.LineUID]: storageTypes.session,
  [storageKeys.LoginInfo]: storageTypes.local,
  [storageKeys.MemberId]: storageTypes.local,
  [storageKeys.MyFavorieState]: storageTypes.local,
  [storageKeys.InsurceProcessState]: storageTypes.session,
  [storageKeys.HomeAnnounceChecked]: storageTypes.session,
  [storageKeys.TravelInsAnnounceChecked]: storageTypes.session,
  [storageKeys.CarInsAnnounceChecked]: storageTypes.session,
  [storageKeys.MotoInsAnnounceChecked]: storageTypes.session,
  [storageKeys.PetInsAnnounceChecked]: storageTypes.session,
  [storageKeys.MobileDeviceInsAnnounceChecked]: storageTypes.session,
  [storageKeys.FireInsAnnounceChecked]: storageTypes.session,
  [storageKeys.TravelProgramCode]: storageTypes.session,
  [storageKeys.CarProgramCode]: storageTypes.session,
  [storageKeys.MotoProgramCode]: storageTypes.session,
  [storageKeys.FireProgramCode]: storageTypes.session,
  [storageKeys.MobileDeviceProgramCode]: storageTypes.session,
  [storageKeys.PetProgramCode]: storageTypes.session,
  [storageKeys.InsuredRange]: storageTypes.session,
  [storageKeys.PrizeWinnerSn]: storageTypes.session,
  [storageKeys.InsurceProcessCarState]: storageTypes.session,
  [storageKeys.InsurceProcessMotoState]: storageTypes.session,
  [storageKeys.InsurceProcessMobileDeviceState]: storageTypes.session,
  [storageKeys.InsurceProcessFireState]: storageTypes.session,
  [storageKeys.InsurceProcessPetState]: storageTypes.session,
  [storageKeys.PromotionDetail]: storageTypes.session,
  [storageKeys.NewsDetail]: storageTypes.session,
  [storageKeys.TempInfo]: storageTypes.session,
  [storageKeys.PolicyInquiry]: storageTypes.session,
  [storageKeys.TravelActiveProdId]: storageTypes.session,
  [storageKeys.CarActiveProdId]: storageTypes.session,
  [storageKeys.MotoActiveProdId]: storageTypes.session,
  [storageKeys.MobileDeviceActiveProdId]: storageTypes.session,
  [storageKeys.FireActiveProdId]: storageTypes.session,
  [storageKeys.PetActiveProdId]: storageTypes.session,
  [storageKeys.UnauthorizedMsg]: storageTypes.local,
  [storageKeys.ClaimAccidentDate]: storageTypes.session,
  [storageKeys.CorrectionFormVal]: storageTypes.session,
  [storageKeys.Lng]: storageTypes.local,
  [storageKeys.Vehregdata]: storageTypes.session
};

export default storageDefines;
